import React from 'react'
import styles from './styles'
import CloseIcon from 'material-ui/svg-icons/content/clear'

const Dialog = ({ renderActions, renderContent, closeAction }) => (
  <div style={styles.backdrop}>
    <div style={styles.container}>
      {closeAction ? (
        <div style={styles.close}>
          <CloseIcon
            onClick={() => closeAction()}
            hoverColor={'#34c240'}
            style={{
              color: '#bbb',
              cursor: 'pointer',
              padding: 2,
              height: 25,
              width: 25
            }}
          />
        </div>
      ) : null}
      <div style={styles.content}>{renderContent()}</div>
      <div style={styles.actions}>{renderActions()}</div>
    </div>
  </div>
)

export default Dialog



// WEBPACK FOOTER //
// ./src/components/common/dialog/common/index.js